import React from "react";
import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";

interface MintedStatusBadgeProps {
  isMinted: boolean;
  className?: string;
}

const MintedStatusBadge: React.FC<MintedStatusBadgeProps> = ({ isMinted, className = "" }) => {
  if (isMinted) {
    return (
      <Badge 
        variant="outline"
        className={`border-amber-500 text-amber-500 bg-transparent font-semibold ${className}`}
      >
        <span className="mr-1 text-amber-500">▰</span>
        Minted
      </Badge>
    );
  }

  return (
    <Badge 
      variant="outline" 
      className={`border-muted-foreground/50 text-muted-foreground bg-transparent ${className}`}
    >
      <Clock className="h-3 w-3 mr-1" />
      Draft
    </Badge>
  );
};

export default MintedStatusBadge;
